import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
  },
  rowTop: {
    display: 'flex',
    alignItems: 'baseline',
  },
  cpScoreHeaderChild: {
    width: 48,
    minWidth: 48,
    textAlign: 'center',
    margin: 0,
  },
  headerChildName: {
    margin: 0,
    marginRight: theme.spacing(1),
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    overflowX: 'auto',
  },
  checklistHeader: {
    top: 48,
    zIndex: 2,
    paddingLeft: theme.spacing(2),
    backgroundColor: '#f5f5f5',
    color: theme.palette.text.primary,
    boxShadow: (p) => (p.printView ? 'none' : '0px 5px 5px -3px grey'),
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
  },
  headerBtn: {
    color: 'red',
  },
  headerCriteria: {
    lineHeight: 0,
    position: 'absolute',
    fontSize: '10px',
    bottom: theme.spacing(1),
    color: theme.palette.action.disabled,
    fontWeight: 'normal',
  },
}));
